'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
export type InteractiveProposalActionState = 'idle' | 'applying' | 'applied' | 'cancelled' | 'error';
export type InteractiveProposalActionController = {
  state: InteractiveProposalActionState;
  statusMessage: string | null;
  errorMessage: string | null;
  isApplying: boolean;
  isFinal: boolean;
  beginApplying: () => void;
  markApplied: (message?: string) => void;
  markCancelled: (message?: string) => void;
  markError: (message: string) => void;
};
export function useInteractiveProposalActionState() {
  const $ = _c(10);
  const [state, setState] = useState("idle");
  const [statusMessage, setStatusMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setState("applying");
      setStatusMessage(null);
      setErrorMessage(null);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const beginApplying = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const message = t2 === undefined ? "Applied." : t2;
      setState("applied");
      setStatusMessage(message);
      setErrorMessage(null);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const markApplied = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = t3 => {
      const message_0 = t3 === undefined ? "Cancelled." : t3;
      setState("cancelled");
      setStatusMessage(message_0);
      setErrorMessage(null);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const markCancelled = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = message_1 => {
      setState("error");
      setStatusMessage(null);
      setErrorMessage(message_1);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const markError = t3;
  const t4 = state === "applying";
  const t5 = state === "applied" || state === "cancelled";
  let t6;
  if ($[4] !== errorMessage || $[5] !== state || $[6] !== statusMessage || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      state,
      statusMessage,
      errorMessage,
      isApplying: t4,
      isFinal: t5,
      beginApplying,
      markApplied,
      markCancelled,
      markError
    };
    $[4] = errorMessage;
    $[5] = state;
    $[6] = statusMessage;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}